import { useEffect, useState } from "react";
import { Outlet } from "react-router-dom";
import Sidebar from "@/components/common/Sidebar";
import Header from "@/components/common/Header";
import { SidebarProvider, useSidebar } from "@/components/ui/sidebar";
import { ArrowUp } from "lucide-react";
import bgImage from "../../assets/s11.jpg";

const LayoutContent = () => {
  const { open } = useSidebar();
  const [showGoTop, setShowGoTop] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 200) setShowGoTop(true);
      else setShowGoTop(false);
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  return (
    <div className="flex min-h-screen w-full">
      <Sidebar />

      <div
        className={`
          flex-1 flex flex-col transition-all duration-300
          ${open ? "md:ml-64" : "md:ml-0"}
        `}
        style={{
          backgroundImage: `url(${bgImage})`,
          backgroundAttachment: "fixed",
          backgroundSize: "cover",
          backgroundPosition: "center",
        }}
      >
        <Header />

        <main className="flex-1 overflow-y-auto overflow-x-hidden p-2 w-[100%] pb-20 bg-white/50 relative">
          <Outlet />

          {showGoTop && (
            <button
              onClick={scrollToTop}
              className="fixed bottom-6 right-6 bg-blue-600 text-white p-3 rounded-full shadow-lg hover:bg-blue-700 transition-all"
            >
              <ArrowUp className="h-5 w-5" />
            </button>
          )}
        </main>
      </div>
    </div>
  );
};

const DashboardLayout = () => {
  return (
    <SidebarProvider defaultOpen={true}>
      <LayoutContent />
    </SidebarProvider>
  );
};

export default DashboardLayout;
